import React, { useState } from 'react';
import { CalendarDays, X } from 'lucide-react';
import { Popover, PopoverTrigger, PopoverContent } from './ui/popover';
import { Calendar } from './ui/calendar';
import { useLang } from '../i18n/LangContext';
import { LOCALES, fmtDate, toIsoDay, fromIsoDay } from '../lib/dates';

const PH = { es: 'dd-mm-aaaa', pt: 'dd-mm-aaaa', en: 'dd-mm-yyyy' };
const CLEAR = { es: 'Borrar fecha', pt: 'Limpar data', en: 'Clear date' };

// Day-month-year picker; calendar language follows the interface. value/onChange use 'YYYY-MM-DD'
export const DateField = ({ value, onChange, testid, className = '', clearable = false }) => {
  const { lang } = useLang();
  const [open, setOpen] = useState(false);
  const sel = fromIsoDay(value);
  const pick = (d) => { onChange(d ? toIsoDay(d) : ''); setOpen(false); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className={`inline-flex items-center gap-2 rounded-lg border border-slate-600 bg-slate-800 px-3 py-1.5 text-sm text-white hover:border-blue-500 transition-colors ${className}`}>
          <CalendarDays className="h-4 w-4 text-blue-300" />
          <span className={value ? '' : 'text-slate-400'}>{value ? fmtDate(value) : PH[lang] || PH.es}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto border-slate-700 bg-slate-900 p-0 text-slate-100" data-testid={`${testid}-calendar`}>
        <Calendar mode="single" selected={sel} defaultMonth={sel} onSelect={pick} locale={LOCALES[lang] || LOCALES.es} weekStartsOn={lang === 'en' ? 0 : 1}
          captionLayout="dropdown-buttons" fromYear={1950} toYear={new Date().getFullYear() + 10}
          classNames={{ caption_label: 'hidden', caption_dropdowns: 'flex gap-1', dropdown: 'rounded bg-slate-800 px-1 text-sm text-white border border-slate-600', vhidden: 'hidden' }} />
        {clearable && value && (
          <button type="button" onClick={() => pick(null)} data-testid={`${testid}-clear`} className="flex w-full items-center justify-center gap-1 border-t border-slate-700 py-2 text-xs text-slate-300 hover:text-white">
            <X className="h-3 w-3" />{CLEAR[lang] || CLEAR.es}
          </button>
        )}
      </PopoverContent>
    </Popover>
  );
};
